import React from "react";
import SubrecipeDetailBody from "./SubrecipeDetailBody";
import type { Subrecipe } from "../../../../../services/subrecipes/subrecipesService";

interface SubrecipeDetailModalProps {
    // null → create mode (empty draft); a string → edit that subrecipe.
    subrecipeId: string | null;
    onClose: () => void;
    // Called with the saved subrecipe after a create/update, and with nothing after
    // a delete — hosts that only refresh a list can ignore the argument.
    onSaved?: (saved?: Subrecipe) => void;
    /** Raise the panel above the host it was opened from — see SubrecipeDetailBody. */
    zIndexClass?: string;
    allowEmptyIngredients?: boolean;
    seedName?: string;
    restaurantId?: string;
}

/**
 * The subrecipe editor as a right-hand slide-over. All editor behavior lives in
 * SubrecipeDetailBody; this wrapper just selects the slide-over chrome (portal +
 * backdrop + sliding panel + maximize width). Other hosts mount the body directly
 * with `host="embedded"`.
 */
const SubrecipeDetailModal: React.FC<SubrecipeDetailModalProps> = (props) => (
    <SubrecipeDetailBody {...props} host="slideOver" />
);

export default SubrecipeDetailModal;
